module.exports = __webpack_public_path__ + "img/messages.fa08f884.svg";